import React from 'react';
import {
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarDensitySelector,
} from '@mui/x-data-grid-pro';

const CustomToolbar = ({ fileName, showExport }) => {
  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />
      <GridToolbarDensitySelector />
      {!showExport && (<GridToolbarExport
        csvOptions={{ fileName: fileName, utf8WithBom: true }}
      />)}
    </GridToolbarContainer>
  );
};

export default CustomToolbar;
